/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

:host {
  display: block;

  --qds-theme-control-border: var(--qds-theme-popup-background);
  --qds-theme-control-text-standard: var(--qds-theme-popup-background);
  --qds-theme-interactive-background-pressed: none;
  --qds-theme-interactive-background-hover: rgb(255 255 255 / 22%);
}

.qds-web-title {
  font-family: var(--qds-font-family-brand);
  font-size: var(--qds-main-subsection-card-title-emphasized);
  font-style: normal;
  font-weight: bold;
  margin: 0;
  color: var(--qds-theme-signature-color-contrast);
  line-height: 24px;
  text-decoration: none;

  &:focus-within {
    text-decoration: underline;
  }
}

.web {
  position: relative;
  background: var(--qds-theme-signature-color-default);
  display: flex;
  border-radius: var(--qds-control-border-radius);
  justify-content: space-between;
  max-width: 928.653px;
  min-width: 583.837px;

  .body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--qds-navigation-subsection-gap-children-unrelated);
    gap: 8px;
  }

  &.qds-web-selectable:hover {
    .qds-web-title {
      text-decoration: underline;
    }
  }
}

.mobile {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: var(--qds-control-border-radius);
  background: var(--qds-theme-signature-color-default);
  color: var(--qds-theme-signature-contrast);
  align-items: flex-start;
  padding: var(--qds-navigation-subsection-gap-children-unrelated);
  gap: var(--qds-navigation-subsection-padding-vertical);

  .body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  &.qds-web-selectable:hover {
    .qds-web-title {
      text-decoration: underline;
    }
  }
}

.qds-web-title-tag-link {
  position: absolute;
  inset: 0;
  margin: 0;
  color: transparent;
  border-radius: var(--qds-control-border-width);

  &:focus {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: var(--qds-focus-border-offset);
  }
}

p {
  font: var(--qds-text-subdued);
  color: var(--qds-theme-signature-color-contrast);
  margin: 0;
  padding: 0;
  text-align: start;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
}

img {
  height: 104px;
  width: 190px;
  flex-shrink: 0;
  border-radius: 0 3.918px 3.918px 0;
}

.button-wrapper {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.button-padding {
  padding-inline-end: var(--qds-navigation-subsection-gap-children-unrelated);
}
